import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import CancelIcon from "@mui/icons-material/Cancel";
import HistoryHealt from "./HistoryHealt";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import { getAnswersOfUser } from "../../../../services/rest/users/medicalQuestions";

const ModalViewHistory = ({ open, setOpen, setLoading, selectedUser }) => {
  const [responses, setResponses] = useState({});
  const [selectedHistory, setSelectedHistory] = useState("general");
  const handleClose = useCallback(() => setOpen(false), [setOpen]);

  const handleChange = (event) => {
    setSelectedHistory(event.target.value);
  };

  const getUserHistoryById = useCallback(async () => {
    try {
      setLoading(true);
      //Hacemos la peticion a la API para obtener el historial de salud al usuario dependiento del rol del usuario se obtendra la seccion de preguntas y llenamos responses con la respuesta de la peticion
      const dataResponse = await getAnswersOfUser(selectedUser?._id);
      // console.log("Respuestas de usuario", dataResponse);

      setResponses(dataResponse);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleClose();
      // console.log("Error en modal historila", error);
      toast.error("Usuario no encontrado intentelo más tarde.");
    }
  }, [handleClose, setLoading, selectedUser]);

  useEffect(() => {
    if (open) {
      setLoading(true);
      getUserHistoryById();
    }
  }, [getUserHistoryById, open]);

  return (
    <Dialog open={open}>
      <DialogContent
        sx={{
          padding: 5,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          alignItems: "center",
        }}
      >
        <DialogTitle sx={{ display: "flex", gap: 3, alignItems: "center" }}>
          <MedicalServicesIcon sx={{ color: "#e7ef7d", fontSize: 36 }} />
          <Typography sx={{ textAlign: "center", fontSize: 24 }}>
            Historial de {selectedUser?.firstName ?? "Usuario"}
          </Typography>
        </DialogTitle>
        <FormControl sx={{ width: 200 }}>
          <InputLabel id="demo-simple-select-label">
            Seleccione el historial
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedHistory}
            label="Age"
            onChange={handleChange}
          >
            <MenuItem value={"general"}>General</MenuItem>
            <MenuItem value={"nutrition"}>Nutrición</MenuItem>
            <MenuItem value={"psicology"}>Psicológico</MenuItem>
            <MenuItem value={"physical"}>Físico</MenuItem>
            <MenuItem value={"trainn"}>Entrenamiento</MenuItem>
            <MenuItem value={"preferences"}>Preferencias</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ paddingTop: 2 }}>
          <HistoryHealt
            responses={
              selectedHistory === "general"
                ? (responses?.general ?? {})
                : selectedHistory === "nutrition"
                  ? (responses?.nutricion ?? {})
                  : selectedHistory === "psicology"
                    ? (responses?.psicologo ?? {})
                    : selectedHistory === "physical"
                      ? (responses?.fisico ?? {})
                      : selectedHistory === "trainn"
                        ? (responses?.entrenamiento ?? {})
                        : selectedHistory === "preferences"
                          ? (responses.preferencias ?? {})
                          : {}
            }
            selectedHistory={selectedHistory}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d" }}
            onClick={handleClose}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalViewHistory;
